import { Box, Button, Paper, Typography, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import * as services from "../../services/services";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";

const OwnerCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [owner, setOwner] = useState({
    firstName: "",
    lastName: "",
    idCard: "",
    phoneNumber: "",
    address: "",
    subDistrict: "",
    district: "",
    province: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleFile = (file) => {
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleCreate = async () => {
    try {
      let imageUrl = "";

      if (imageFile) {
        const uploadRes = await services.uploadImage(imageFile, "owner");
        imageUrl = uploadRes.data.url;
      }

      await services.createOwner({
        ...owner,
        imageUrl,
      });

      toast.success("สร้างเจ้าของสำเร็จ");
      navigate("/owner/list");
    } catch (err) {
      if (err.response?.status === 409) {
        toast.error("ข้อมูลซ้ำ (เลขบัตร หรือ เบอร์โทร)");
      } else {
        toast.error("เกิดข้อผิดพลาด");
      }
    }
  };

  return (
    <>
      <AppBreadcrumbs />
      <Toaster position="bottom-left" />
      <Box sx={{ maxWidth: 1400, mx: "auto", mt: 3 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h5" fontWeight={600} mb={3}>
            เพิ่มเจ้าของใหม่
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 2fr" },
              gap: 4,
            }}
          >
            <Box
              sx={{
                border: "2px dashed #ddd",
                borderRadius: 3,
                p: 2,
                textAlign: "center",
                cursor: "pointer",
                minHeight: 280,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fafafa",
              }}
              onClick={() =>
                document.getElementById("create-owner-image")?.click()
              }
            >
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="owner"
                  style={{
                    maxWidth: "100%",
                    maxHeight: 260,
                    borderRadius: 12,
                  }}
                />
              ) : (
                <Typography color="text.secondary">
                  คลิกเพื่ออัปโหลดรูป
                </Typography>
              )}

              <input
                id="create-owner-image"
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => {
                  if (e.target.files?.length) {
                    handleFile(e.target.files[0]);
                  }
                }}
              />
            </Box>
            <Box>
              <Box
                sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}
              >
                <TextField
                  label="ชื่อ"
                  value={owner.firstName}
                  onChange={(e) =>
                    setOwner({ ...owner, firstName: e.target.value })
                  }
                  fullWidth
                />

                <TextField
                  label="นามสกุล"
                  value={owner.lastName}
                  onChange={(e) =>
                    setOwner({ ...owner, lastName: e.target.value })
                  }
                  fullWidth
                />
              </Box>

              <TextField
                label="เลขบัตรประชาชน"
                fullWidth
                sx={{ mt: 2 }}
                value={owner.idCard}
                onChange={(e) => setOwner({ ...owner, idCard: e.target.value })}
              />

              <TextField
                label="เบอร์โทร"
                fullWidth
                sx={{ mt: 2 }}
                value={owner.phoneNumber}
                onChange={(e) =>
                  setOwner({ ...owner, phoneNumber: e.target.value })
                }
              />

              <TextField
                label="ที่อยู่"
                fullWidth
                multiline
                rows={2}
                sx={{ mt: 2 }}
                value={owner.address}
                onChange={(e) =>
                  setOwner({ ...owner, address: e.target.value })
                }
              />

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: 2,
                  mt: 2,
                }}
              >
                <TextField
                  label="ตำบล"
                  value={owner.subDistrict}
                  onChange={(e) =>
                    setOwner({ ...owner, subDistrict: e.target.value })
                  }
                />

                <TextField
                  label="อำเภอ"
                  value={owner.district}
                  onChange={(e) =>
                    setOwner({ ...owner, district: e.target.value })
                  }
                />

                <TextField
                  label="จังหวัด"
                  value={owner.province}
                  onChange={(e) =>
                    setOwner({ ...owner, province: e.target.value })
                  }
                />
              </Box>
              <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
                <Button variant="outlined" onClick={() => navigate("/owners")}>
                  ยกเลิก
                </Button>

                <Button variant="contained" onClick={handleCreate}>
                  บันทึก
                </Button>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default OwnerCreate;
